import { defineComponent as _defineComponent } from 'vue'
import CountDownTimer from '@/components/sponsored-recommendations/campaigns/CountDownTimer.vue';
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderLogoVideoControls',
  props: {
    isMuted: { type: Boolean, default: false },
    isPaused: { type: Boolean },
    currentTime: null,
    videoDuration: null,
    showCountDownTimer: { type: Boolean },
    showCountdownText: { type: Boolean },
    showProviderIcon: { type: Boolean }
  },
  emits: ['toggleMute', 'togglePlayPause'],
  setup(__props: any, { emit: emits }) {

const props = __props as { isMuted: boolean, isPaused: boolean, currentTime: number, videoDuration: number, showCountDownTimer?: boolean, showCountdownText?: boolean, showProviderIcon?: boolean };





const secondsLeft = computed(() => Math.ceil(Math.max(0, props.videoDuration - props.currentTime)));

const volumeIcon = computed(() => {
	const filename = props.isMuted ? 'volume-xmark' : 'volume-high';
	return `/${ASSETS_DIR}/img/sponsored-recommendation-assets/${filename}.svg`;
});

const playIcon = computed(() => {
	const filename = props.isPaused ? 'player-play' : 'player-pause';
	return `/${ASSETS_DIR}/img/sponsored-recommendation-assets/${filename}.svg`;
});

function handleToggleMute() {
	emits('toggleMute');
}

function handleTogglePlayPause() {
	emits('togglePlayPause');
}

return { __sfc: true,props, emits, secondsLeft, volumeIcon, playIcon, handleToggleMute, handleTogglePlayPause, CountDownTimer }
}

})